import { createSlice } from "@reduxjs/toolkit";
import { EmployeesProfilebuilderState } from "./types";
import { ErrorType } from "@/shared/types";
import { fetchEmployeesForm } from "./employees-profilebuilder-thunk";

const initialState: EmployeesProfilebuilderState = {
    formFields: [],
    formId: "",
    formError: null,
    isFormLoading: false,
    isFormFirstLoad: true
}

const employeesProfilebuilderSlice = createSlice({
    name: 'employeesProfilebuilder',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchEmployeesForm.pending, (state) => {
            state.isFormLoading = true
            state.formError = null
        })
        .addCase(fetchEmployeesForm.fulfilled, (state, action) => {
            state.isFormLoading = false
            state.isFormFirstLoad = false
            state.formError = null
            state.formFields = action.payload.template
            state.formId = action.payload.id
        })
        .addCase(fetchEmployeesForm.rejected, (state, action) => {
            state.formError = action.payload as ErrorType ?? null
            state.isFormLoading = false
        })
    },
})

export default employeesProfilebuilderSlice.reducer